module.exports = __webpack_public_path__ + "img/Grid-Dark.ea4b92a3.svg";